<template>
  <el-container>
  <el-header class="el-header"  style="background:#2d3a4b">
    <Header></Header>
  </el-header>
  <el-container>
    <el-aside width="200px">
      <Sliber></Sliber>
    </el-aside>
    <el-container>
      <el-main>
      <el-breadcrumb>
        <el-breadcrumb-item class="line" separator-class="el-icon-arrow-right" :to="{ path:  $route.path }">{{ $route.meta.title}}</el-breadcrumb-item>
        </el-breadcrumb>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</el-container>
</template>
<script>
import Header from './components/Header.vue'
import Sliber from './components/Sliber.vue'
export default {
    name: 'Dashboard',
    data() {
      return {
      }
    },
    components:{
      Header,
      Sliber
    }
}
</script>
<style scoped>
.el-breadcrumb{
      height: 10px;
      padding: 20px;
      border-radius: 4px; /* 圆角 */
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); /* element提供的边框 */
}

/* 左边的那条绿线 */
.line{
      border-left: 3px solid #31c17b;
      padding-left: 10px;
}
.el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
</style >

  
  <!-- <style>
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
</style> -->


// WEBPACK FOOTER //
// src/views/dashboard/Dashboard.vue